/**
 * 内容管理后台入口
 * 路由 /cms（blank-layout，不受大屏 7680 缩放影响）
 * 未登录显示登录框，登录后左侧为页面导航，右侧为对应编辑面板
 */
<template>
  <div class="cms">
    <!-- 登录 -->
    <div class="cms-login" v-if="!authed">
      <form class="cms-login-card" @submit.prevent="doLogin">
        <h1 class="cms-login-title">牦牛酪蛋白产业数智平台</h1>
        <p class="cms-login-sub">内容管理后台</p>
        <div class="cms-field">
          <label>账号</label>
          <el-input v-model="form.account" autocomplete="username" placeholder="请输入账号"></el-input>
        </div>
        <div class="cms-field">
          <label>密码</label>
          <el-input v-model="form.password" type="password" autocomplete="current-password"
            placeholder="请输入密码" @keyup.enter.native="doLogin"></el-input>
        </div>
        <el-button class="cms-login-btn" type="primary" :loading="logining" @click="doLogin">登 录</el-button>
        <p class="cms-login-tip" :class="{ error: loginError }">{{ loginError || '账号沿用大屏登录账号' }}</p>
        <p class="cms-back"><a href="/#/index" target="_blank">← 返回大屏</a></p>
      </form>
    </div>

    <!-- 主界面 -->
    <div class="cms-shell" v-else>
      <aside class="cms-aside">
        <div class="cms-brand">
          <span class="cms-brand-dot"></span>
          <span>内容管理后台</span>
        </div>
        <nav class="cms-nav">
          <div class="cms-nav-group" v-for="g in groups" :key="g.group">
            <p class="cms-nav-group-title">{{ g.group }}</p>
            <a class="cms-nav-item" v-for="p in g.items" :key="p.scope"
              :class="{ active: active === p.scope }" @click="go(p.scope)">
              {{ p.title }}
              <i class="cms-dot" v-if="dirtyMap[p.scope]"></i>
            </a>
          </div>
          <div class="cms-nav-group">
            <p class="cms-nav-group-title">资源</p>
            <a class="cms-nav-item" :class="{ active: active === '__media' }" @click="go('__media')">素材库</a>
          </div>
        </nav>
        <div class="cms-aside-foot">
          <span>{{ user && user.name }} · {{ user && user.account }}</span>
          <el-button size="mini" type="text" @click="doLogout">退出</el-button>
        </div>
      </aside>

      <main class="cms-main">
        <div class="cms-status" :class="{ off: !online }">
          <span class="cms-status-dot"></span>
          {{ online ? '内容服务已连接' : '内容服务未连接，当前为本地默认内容（后台保存功能不可用）' }}
          <a class="cms-status-link" href="/#/index" target="_blank">打开大屏预览</a>
        </div>
        <PagePanel v-if="active && active !== '__media'" :key="active" :scope="active" />
        <MediaPanel v-else />
      </main>
    </div>
  </div>
</template>

<script>
import api, { setAuth, currentUser, isLogin as hasToken } from '@/cms/api'
import { state, load } from '@/cms/store'
import { groupedPages } from '@/cms/schema'
import PagePanel from './PagePanel.vue'
import MediaPanel from './MediaPanel.vue'

export default {
  name: 'cms',
  components: { PagePanel, MediaPanel },
  data() {
    return {
      authed: false,
      logining: false,
      loginError: '',
      form: { account: '', password: '' },
      user: null,
      active: 'index',
      online: false,
    }
  },
  computed: {
    groups() { return groupedPages() },
    dirtyMap() { return state.dirty },
  },
  created() {
    if (hasToken()) {
      this.authed = true
      this.user = currentUser()
      this.refresh()
      api.verify().catch(() => {
        this.authed = false
        this.loginError = '登录已过期，请重新登录'
      })
    }
  },
  mounted() { document.body.classList.add('cms-open') },
  activated() { document.body.classList.add('cms-open') },
  deactivated() { document.body.classList.remove('cms-open') },
  beforeDestroy() { document.body.classList.remove('cms-open') },
  methods: {
    async doLogin() {
      if (!this.form.account || !this.form.password) {
        this.loginError = '请输入账号和密码'
        return
      }
      this.logining = true
      this.loginError = ''
      try {
        const res = await api.login(this.form.account, this.form.password)
        setAuth(res.token, res.user)
        this.user = res.user
        this.authed = true
        await this.refresh()
      } catch (e) {
        this.loginError = e.message || '登录失败'
      } finally {
        this.logining = false
      }
    },
    doLogout() {
      setAuth(null, null)
      this.authed = false
      this.user = null
    },
    async refresh() {
      await load()
      this.online = state.online
    },
    go(scope) { this.active = scope },
  },
}
</script>

<style lang="less" scoped>
.cms {
  position: absolute;
  inset: 0;
  background: #050f24;
  color: #d8e8ff;
  font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
}

/* ---------- 登录 ---------- */
.cms-login { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; background: radial-gradient(ellipse at 50% 40%, #0d2b56 0%, #050f24 70%); }
.cms-login-card { width: 420px; padding: 40px 36px 28px; border-radius: 16px; background: rgba(13, 42, 84, .72); border: 1px solid rgba(79, 163, 255, .3); box-shadow: 0 24px 80px rgba(0, 0, 0, .45); }
.cms-login-title { margin: 0; font-size: 18px; color: #eaf3ff; text-align: center; letter-spacing: 2px; }
.cms-login-sub { margin: 8px 0 26px; font-size: 12px; color: #9fc0e8; text-align: center; letter-spacing: 6px; }
.cms-field { margin-bottom: 16px; }
.cms-field label { display: block; margin-bottom: 6px; font-size: 12px; color: #9fc0e8; }
.cms-login-btn { width: 100%; margin-top: 8px; letter-spacing: 6px; }
.cms-login-tip { margin: 14px 0 0; font-size: 11px; color: #6f8bb5; text-align: center; }
.cms-login-tip.error { color: #ff7a6b; }
.cms-back { margin: 18px 0 0; text-align: center; }
.cms-back a { color: #7fe3ff; font-size: 11px; text-decoration: none; }

/* ---------- 主框架 ---------- */
.cms-shell { position: absolute; inset: 0; display: flex; }
.cms-aside { width: 250px; flex: none; display: flex; flex-direction: column; background: rgba(8, 24, 52, .9); border-right: 1px solid rgba(79, 163, 255, .18); }
.cms-brand { display: flex; align-items: center; gap: 10px; padding: 18px 16px; font-size: 13px; color: #eaf3ff; border-bottom: 1px solid rgba(79, 163, 255, .15); }
.cms-brand-dot { width: 10px; height: 10px; border-radius: 50%; background: #31ffff; box-shadow: 0 0 12px #31ffff; }
.cms-nav { flex: 1; overflow: auto; padding: 12px 10px; }
.cms-nav-group { margin-bottom: 16px; }
.cms-nav-group-title { margin: 0 0 8px; padding: 0 8px; font-size: 11px; color: #5c7aa8; letter-spacing: 2px; }
.cms-nav-item { position: relative; display: block; padding: 9px 12px; margin-bottom: 4px; border-radius: 8px; font-size: 12px; color: #b9d2ef; cursor: pointer; transition: all .16s; text-decoration: none; }
.cms-nav-item:hover { background: rgba(79, 163, 255, .12); color: #eaf3ff; }
.cms-nav-item.active { background: rgba(49, 255, 255, .14); color: #7fe3ff; box-shadow: inset 2px 0 0 #31ffff; }
.cms-dot { position: absolute; right: 12px; top: 50%; width: 6px; height: 6px; margin-top: -3px; border-radius: 50%; background: #ffc857; }
.cms-aside-foot { display: flex; align-items: center; justify-content: space-between; padding: 12px 14px; border-top: 1px solid rgba(79, 163, 255, .15); font-size: 11px; color: #6f8bb5; }

.cms-main { flex: 1; min-width: 0; overflow: auto; padding: 24px 30px 60px; }
.cms-status { display: flex; align-items: center; gap: 8px; margin-bottom: 20px; padding: 8px 14px; border-radius: 8px; background: rgba(49, 229, 139, .1); border: 1px solid rgba(49, 229, 139, .28); font-size: 11px; color: #9ee8c4; }
.cms-status.off { background: rgba(255, 200, 87, .1); border-color: rgba(255, 200, 87, .3); color: #ffd98a; }
.cms-status-dot { width: 8px; height: 8px; border-radius: 50%; background: #31e58b; box-shadow: 0 0 10px #31e58b; }
.cms-status.off .cms-status-dot { background: #ffc857; box-shadow: 0 0 10px #ffc857; }
.cms-status-link { margin-left: auto; color: #7fe3ff; text-decoration: none; }
</style>
